import { useUserDetails } from "./useAuthQueries"
import { usePortfolios } from "./usePortfolioQueries"

export function useActivePortfolio() {
  const { data: userDetails } = useUserDetails()
  const { data: portfolios = [] } = usePortfolios()

  const activePortfolioId = userDetails?.data?.activePortfolioId
  const activePortfolioName =
    portfolios.find((p) => p.id === activePortfolioId)?.name ?? ""

  const quotaLimit = userDetails?.data?.organisation?.homeQuota ?? 5
  const currentCount = userDetails?.data?.organisation?.totalHomes ?? 0
  const isQuotaReached = currentCount >= quotaLimit

  return { activePortfolioId, activePortfolioName, isQuotaReached, quotaLimit, currentCount }
}
